import styled from 'styled-components';

import { Card as DefaultCard } from 'ui/components/shared';
import { spacing } from 'ui/theme/utils';

export const Card = styled(DefaultCard)`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.16);
  padding: ${({ theme }) => theme.spacing.s};
`;

export const CardTitle = styled.h3`
  text-align: left;
  font-weight: 600;
  font-size: 15px;
  letter-spacing: 0.7px;
  color: #333;
  ${(props) => spacing(props)}
`;
